var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"active":!_vm.disableTooltip,"label":_vm.label,"animated":"","type":"is-white"}},[_c('div',{staticClass:"ls-service-status-indicator",style:({ background: _vm.color })})])}
var staticRenderFns = []

export { render, staticRenderFns }